import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latest = articles.slice(3, 9);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新资讯
          </h2>
          <p className="text-sm text-foreground-600 mt-2">实时追踪大桥未久最新动态</p>
        </div>
        <Link
          to="/category/fan-news"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          更多资讯 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {latest.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className={`group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all ${
              index === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
            }`}
          >
            <div className={`flex ${index === 0 ? 'flex-col sm:flex-row' : 'flex-col'}`}>
              <div className={`relative overflow-hidden ${index === 0 ? 'sm:w-2/5 h-48 sm:h-auto' : 'h-44'}`}>
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`p-4 md:p-5 ${index === 0 ? 'sm:w-3/5' : ''}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.publishedAt}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full">
                    {article.category === 'latest' ? '最新作品' :
                     article.category === 'masterpiece' ? '代表作' :
                     article.category === 'photo-book' ? '写真集' :
                     article.category === 'fan-news' ? '粉丝资讯' : '作品全集'}
                  </span>
                </div>
                <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 ${
                  index === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category/fan-news"
          className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors"
        >
          更多资讯 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}